if (typeof Shopify === "undefined") {
  window.Shopify = {};
}
if (typeof Shopify.getCart === "undefined") {
  Shopify.getCart = function (callback, cart) {
    if (!cart) {
      return jQuery.getJSON("/cart.js", function (cart, textStatus, xhr) {
        if (typeof callback === "function") {
          callback(cart, textStatus, xhr);
        } else if (typeof Shopify.onCartUpdate === "function") {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if (typeof callback === "function") {
        callback(cart);
      } else if (typeof Shopify.onCartUpdate === "function") {
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

function changeHeight() {
  if (
    $("body").hasClass("loop-returns-activated") &&
    $(".loop-onstore").length > 0
  ) {
    var loopHeight = $(".loop-onstore").outerHeight();
    $(".mini_cart_wrap").css("height", "calc(100% - " + loopHeight + "px)");
    $(".mini_cart_wrap .mini_cart_bottom").css("padding-top", "10px");
  } else {
    setTimeout(changeHeight, 1000);
  }
}
$("body").on("click", 'form[action="/cart"] .black_btn', function (e) {
  $(this).text("Processing...");
  setTimeout(() => {
    $(this).text("loading please wait");
  }, 3000);
});
$(document).ready(function () {
  // $('form[action="/cart"] .black_btn').on("click", function() {
  //     setTimeout(() => {
  //       $(this).text('loading please wait');
  //     }, 3000);
  //     // setTimeout(() => {
  //     //     $(this).text('Loading now...');
  //     // }, 6000);
  // });
  if ($(".cst-swatch--image").length > 0) {
    $(".cst-swatch--image").each(function (i, ele) {
      var imgURL = $(ele).data("image-src");
      var $img = $("<img>").attr("src", imgURL);

      $img
        .on("load", function () {
          console.log("Swatch Image loaded successfully");
        })
        .on("error", function () {
          console.error("Error loading swatch image:", imgURL);
          $(ele).remove();
        });

      $(ele).append($img);
    });
  }

  if (
    location.pathname == "/account" ||
    location.pathname.includes("/apps/return_prime") ||
    location.pathname.includes("/account/orders/") ||
    location.pathname.includes("/account/addresses")
  ) {
    var titleText = $(".chTitle-Wrapper-Heading-Text").text();
    console.log("titleText ==", titleText);
    $(".chContent-Body-Page").prepend(
      "<div class='chContent-Body-Page-General-header'><h1>" +
        titleText +
        "</h1></div>"
    );
  }

  if (location.pathname == "/account") {
    var html_test = $(
      ".chCBPROWID-TrackingModal .chCBPROWID-TrackingModal-Fulfillment"
    ).html();
    console.log("titleText ==", html_test);
    if (html_test) {
      $(".chCBPROWID-Actions").append(
        "<div class='tracking_div'>" + html_test + "</div>"
      );
    }
  }

  // announcement slider
  var hederHeight = $(".header").height();
  if ($('.announce_slider .swiper-slide').length > 1) {
    var swiper = new Swiper(".announce_slider", {
      slidesPerView: 1,
      // effect: "fade",
      loop: true,
      autoplay: {
        delay: 2500,
      },
    });
  }
  //header fixed
  $(window).scroll(function () {
    var sticky = $(".header");
    scroll = $(window).scrollTop();
    if (scroll >= 100) {
      sticky.addClass("fixed");
      if ($(window).width() > 768) {
        $(".hd_desk_main").css("top", 0);
      }
    } else {
      sticky.removeClass("fixed");
    }
  });

  //header hover
  $(".header_wrapper").hover(function () {
    $(this).toggleClass("result_hover");
    $(".header").toggleClass("header_hover");
  });

  function mobile_menu() {
    $(window).scroll(function () {
      if ($(window).width() < 768) {
        if ($(".header").hasClass("fixed")) {
          $(".hd_desk_main").css("top", $(".header_wrapper").height());
        } else {
          var hederHeight = $(".header").height();
          console.log("0000", hederHeight);
          $(".hd_desk_main").css("top", hederHeight);
        }
      }
    });
  }
  mobile_menu();
  $(window).on("resize orientationchange", function () {
    // headermenu();
    mobile_menu();
  });
  //mobile nav btn click
  $(".hamburger,.menu_close_icon , .menu-overlay").click(function () {
    $(".header_left, body").toggleClass("active_menu");
    $(".has-children").removeClass("is-open");
  });
  function headermenu() {
    if ($(window).width() > 767) {
      $(".first_level_links").hover(function () {
        $(this).find('.main_label').trigger("click");
      });
      $(".mg_menu_list.has-children").hover(function () {
        $(this).find(".acnav__label").trigger("click");
      });
    }
    $("body").on("click", ".acnav__label", function () {
      var label = $(this);
      var parent = label.parent(".has-children");
      if (parent.hasClass("is-open")) {
        parent.removeClass("is-open");
      } else {
        parent.addClass("is-open");
      }
    });
    $("body").on("click", ".main_label", function (e) {
      e.preventDefault();
      var label = $(this);
      var parent = label.closest(".has-children");
      parent.toggleClass("is-open");
      $(".has-children").not(parent).removeClass("is-open");
      setTimeout(function () {
        var winHeight = $(window).outerHeight();
        var hederHeight3 = $(".header").height();
        var footerHeight = $(".hd_footer").height();
        $(".main_mega_wpr").css("height", (winHeight - hederHeight3 - footerHeight - 20));
        var winHeightTop =
          $(".hd_desk_main .has-children.is-open").offset().top - 96;
        $("body").append(
          "<style>.main_mega_wpr:before{top: -" + winHeightTop + "px;}</style>"
        );
      }, 100);
    });
  }
  headermenu();

  $(".back_arrow").click(function () {
    $(this).closest(".hd_nav").find(".has-children").removeClass("is-open");
  });
  $(".mob_back_inner").click(function () {
    $(this)
      .closest(".mega_menu_wpr")
      .find(".has-children")
      .removeClass("is-open");
  });
  //search bar
  $(".search_bar a").click(function (e) {
    e.preventDefault();
    $(".search_input").slideToggle();
    $("body").toggleClass("no-scroll");
    $(".header").css("background", "#fff");
    $(".search-form input").focus();
    var winHeight = $(window).outerHeight();
    // $('.product_search_results').css("max-height", winHeight  - $('.header').innerHeight() - 90);
  });
  $("body").on("click", ".close-search , .predictive-overlay", function (e) {
    $(".search_input").slideUp();
    $("body").removeClass("no-scroll");
    $(".header").css("background", "transparent");
    if ($(this).closest(".search_input_wpr").find("input").val() == "") {
      $(".predictive-search .pro_searh_right").html("");
      $(".predictive-search .submit").hide();
    }
  });
  //hero banner slider
  var hero_banner = new Swiper(".hero_main,.our_space_wpr", {
    slidesPerView: 1,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      slideChange: function () {
        if ($(window).width() < 768) {
          setTimeout(() => {
            var winHeight = $(window).outerHeight();
            $(".hero_section .hero_image").css(
              "height",
              winHeight - $(".swiper-slide-active .hero_content").innerHeight()
            );
          }, 200);
        }
      },
    },
  });
  //hero banner
  function headerspace() {
    var winHeight = $(window).height();

    $(".hero_section").css("height", winHeight);
    var hederHeight = $(".header").height();
    if ($(window).width() < 768) {
      $(".hd_desk_main").css("top", hederHeight);
      $(".hero_section .hero_image").css(
        "height",
        winHeight - $(".swiper-slide-active .hero_content").innerHeight()
      );
    } else {
      $(".hd_desk_main").css("top", 0);
      $(".hero_section .hero_image").css("height", "100%");
    }
    //with out hero section
    if (!$(".wrapper .shopify-section:first").hasClass("Banner")) {
      $(".header").removeClass("header_transparent");
    }
    if ($(".header").hasClass("header_transparent")) {
      $(".wrapper").css("padding-top", "0");
    } else {
      $(".wrapper").css("padding-top", hederHeight);
    }
  }
  headerspace();
  $(window).on("resize orientationchange", function () {
    headerspace();
  });

  //tab
  $("body").on("click", ".tab_view_wrap .tab_link", function (e) {
    e.preventDefault();
    var tab_id = $(this).attr("data-tab");
    var $this = $(this);
    $(".tab_view_wrap .tab_link").removeClass("current");
    $(".latest_view").removeClass("current");
    $(this).addClass("current");
    $(this)
      .closest(".get_tab")
      .find("#" + tab_id)
      .addClass("current");
  });
  // FEATURED CATEGORY tab
  $("body").on("click", "ul.tabs li", function (e) {
    e.preventDefault();
    var tab_id = $(this).attr("data-tab");
    $(this)
      .closest(".fe_category_tab")
      .find("ul.tabs li")
      .removeClass("current");
    $(this)
      .closest(".fe_category_tab")
      .find(".fe_category_item")
      .removeClass("current");
    $(this).addClass("current");
    $(this)
      .closest(".get_tab")
      .find("#" + tab_id)
      .addClass("current");
  });
  //the latest slider
  function proSlider() {
    var swiper = new Swiper(".latest_coll .latest_view_slider", {
      slidesPerView: 1.34,
      spaceBetween: 15,
      draggable: true,
      freeMode: true,
      mousewheelControl: true,
      behavior: "smooth",
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      breakpoints: {
        1180: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
        991: {
          slidesPerView: 3.5,
          // spaceBetween: 16,
        },
        480: {
          slidesPerView: 2.5,
          // spaceBetween: 15,
        },
      },
    });
  }
  proSlider();

  //video play

  $(".u_video_play").on("click", function () {
    if ($(this).closest(".video_poster_img").attr("data-click") == 1) {
      $(".video_poster_img").css("opacity", "1");
    } else {
      $(".video_poster_img").css("opacity", "0");
      if ($(this).closest(".unique_space_wpr").find("video:visible").length) {
        $(this)
          .closest(".unique_space_wpr")
          .find("video:visible")
          .trigger("play");
      } else {
        var get_type = $(this)
          .closest(".unique_space_wpr")
          .find("iframe:visible")
          .attr("src");
        $(this)
          .closest(".unique_space_wpr")
          .find("iframe:visible")
          .attr("src", get_type);
      }
    }
  });

  // The Journal slider
  var swiper = new Swiper(".journal_right_wpr", {
    slidesPerView: 1,
    draggable: true,
    followFinger: true,
    behavior: "smooth",
    navigation: {
      nextEl: ".j_arrow_next",
      prevEl: ".j_arrow_prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
  });

  //join our popup
  $(".vacancies-internal-btn").on("click", function () {
    $(".popup_join_our").addClass("active");
  });
  $(".close_popup, .main-overlay").on("click", function () {
    $(".popup_join_our").removeClass("active");
  });

  $("body").on("click", ".mini_cart", function () {
    $(".mini_cart_drower, body").addClass("active_cart");
    changeHeight();
  });

  $("body").on("click", ".mini_cart_over, .cart_close", function () {
    $(".mini_cart_drower, body").removeClass("active_cart");
  });

  // filter popup
  $("body").on("click", ".ft_btn", function (e) {
    e.preventDefault();
    if (!$(this).next().length == 0) {
      $(this).next().addClass("filter_open");
      $("body").addClass("no-scroll");
    }
  });
  $("body").on("click", ".filter_drower_over, .filter_close", function () {
    $(".filter_drower, body").removeClass("filter_open");
    $("body").removeClass("no-scroll");
  });

  $(
    ".join_our_team_info .filter-box:first-child .filter_heading,.main_faq_sec .faq_main_wpr:first-child .filter-box:first-child .filter_heading,.product_care_sec .filter-box:first-child .filter_heading"
  )
    .addClass("active_ft_menu")
    .siblings(".filter_content")
    .slideDown();
  $("body").on("click", ".filter_heading", function (e) {
    e.preventDefault();
    $(".filter_heading").removeClass("active_ft_menu");
    $(".filter-box .filter_content").slideUp();
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active_ft_menu");
    }

    var tab_id = $(this).parent(".product_care_sec .filter-box").attr("id");
    $(".product_care_sec .tab_scroll li a").removeClass("current");
    $('a[href="#' + tab_id + '"]').addClass("current");
  });

  // single product slider
  (function () {
    "use strict";
    var breakpoint = window.matchMedia("(min-width:768px)");
    var mySwiper;
    var breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };
    var enableSwiper = function () {
      mySwiper = new Swiper(".pdp_media_main", {
        slidesPerView: 1,
        grabCursor: true,
        pagination: {
          el: ".pdp-swiper-pagination",
          clickable: true,
        },
        paginationClickable: true,
      });
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  })();

  function tabSroll() {
    $(window)
      .scroll(function () {
        var scrollDistance = $(window).scrollTop();
        $(".scroll_item").each(function (i) {
          if ($(this).position().top <= scrollDistance) {
            var get_int = parseInt(i) + 1;
            $(".pdp_thumb_inner.active").removeClass("active");
            $('.pdp_thumb_inner[data-img-index="' + get_int + '"]').addClass(
              "active"
            );
          }
        });
      })
      .scroll();
  }
  setTimeout(function () {
    tabSroll();
  }, 1000);

  // COLOUR SWATCHES Popup
  $("body").on("click", ".view_all_swatch > a", function (e) {
    e.preventDefault();
    if (!$(this).next().length == 0) {
      $(this).next().addClass("active_switch");
      $("body").addClass("no-scroll");
    }
  });

  $("body").on("click", ".c_swatch_drower_over, .c_swatch_close", function () {
    $(".c_swatch_drower, body").removeClass("active_switch");
    $("body").removeClass("no-scroll");
  });

  // CONTACT US POPUP
  $("body").on("click", ".contact_us ", function () {
    $(".contact_popup").addClass("conatct_active");
    $("body").addClass("no-scroll");
  });

  $("body").on("click", ".contact_popup_over, .contact_close", function () {
    $(".contact_popup").removeClass("conatct_active");
    $("body").removeClass("no-scroll");
  });

  // gift type
  $("body").on("click", ".gift-type li", function (e) {
    e.preventDefault();
    $(".gift-type li").removeClass("active");
    $(this).addClass("active");
  });

  // BOOK A CONSULTATION
  $(".page_style-consultation .book_con_btn").on("click", function (e) {
    e.preventDefault();
    $(".style_con_drower, body").addClass("book_active");
  });

  $("body").on("click", ".style_con_over, .style_close", function () {
    $(".style_con_drower, body").removeClass("book_active");
  });

  //tab Journal
  // $('body').on('click', '.Journal_wrap .Journal_link', function (e) {
  //     e.preventDefault()
  //     $('.Journal_wrap .Journal_link').removeClass('current');
  //     $(this).addClass('current');
  // });

  // open accordion
  $(
    ".tab_scroll li:first-child a:not(.Support_page .tab_scroll li a, .impact_sec .tab_scroll li a)"
  ).addClass("current");
  $(
    ".tab_scroll li a:not(.Support_page .tab_scroll li a, .impact_sec .tab_scroll li a)"
  ).click(function (event) {
    var tab_id = $(this).attr("title");
    $(".filter_content").slideUp();
    $(".filter_heading").removeClass("active_ft_menu");
    $(".tab_scroll li a").removeClass("current");
    $(this).addClass("current");
    $("#" + tab_id)
      .children(".filter_content")
      .slideDown();
    $("#" + tab_id)
      .children(".filter_heading")
      .addClass("active_ft_menu");
    event.preventDefault();
    var target = $(this).attr("href");
    var page_title = $(this).html().toLowerCase();
    page_title = $("<div/>").html(page_title).text();
    page_title = page_title.replace(/\b\w/g, function (firstLetter) {
      return firstLetter.toUpperCase();
    });

    $(".scroll_items h3").html(page_title);
    // setTimeout(() => {
    //     $('html, body').animate({
    //         scrollTop: $(target).position().top + 30
    //     }, 900)
    // }, 800);
  });

  // More size click
  $("body").on("click", ".more_size a", function () {
    $(this).parent().toggleClass("active");
    $(this).next(".more_size_variant").slideToggle();
  });
  $(".more_size_variant ul li a").click(function () {
    $(this).closest(".pro_content").find(".more_size_variant").slideUp();
    $(this).closest(".pro_content").find(".more_size").removeClass("active");
  });

  // about us page
  $(".about_us_link ul li a").click(function (event) {
    event.preventDefault();
    var target = $(this).attr("href");
    setTimeout(() => {
      $("html, body").animate(
        {
          scrollTop:
            $(target).position().top - $(".header_wrapper").outerHeight(),
        },
        200
      );
    }, 100);
  });
  // CUSTOME dropdown
  $(".nice-select-wrap").addClass("down").find("ul").slideUp(300);
  $(document).on("click", function (e) {
    var clickedElement = $(e.target);

    if (!clickedElement.closest(".nice-select-wrap").length) {
      $(".nice-select-wrap")
        .addClass("down")
        .find("ul")
        .removeClass("active-dropdown")
        .slideUp(300);
      return;
    }

    var clickedDropdown = clickedElement.parents(".nice-select-wrap"),
      clickedParent = clickedDropdown.parent();

    clickedParent
      .parents()
      .find(".nice-select-wrap")
      .not(clickedDropdown)
      .addClass("down")
      .find("ul")
      .removeClass("active-dropdown")
      .slideUp(300);
    if (
      clickedElement.is(".nice-select-wrap a") ||
      clickedElement.is(".nice-select-wrap a span")
    ) {
      var clickedDropdown = clickedElement.parents(".nice-select-wrap");
      var isActive = clickedDropdown.hasClass("down");

      clickedDropdown.toggleClass("down");
      clickedDropdown
        .find("ul")
        .toggleClass("active-dropdown")
        .slideToggle(300);

      var getElement =
        clickedElement.get(0).tagName == "SPAN"
          ? clickedElement.parent("a")
          : clickedElement;
      if (!getElement.hasClass("selected-drodpown-value")) {
        var selectedValue = getElement.data("value");
        clickedDropdown.find(".selected-drodpown-value").html(selectedValue);
        if (
          typeof getElement.attr("data-href") !== "undefined" &&
          getElement.attr("data-href") !== false
            ? (location.href = getElement.data("href"))
            : clickedDropdown
                .find("select")
                .val(selectedValue)
                .trigger("change")
        );
      }
    }
  });

  // collection page variant hover
  $("body").on(
    "mouseenter",
    ".product_card .colour_variant ul li a",
    function (e) {
      console.log("====00000====");
      $(this)
        .parents(".product_card")
        .find("input")
        .removeAttr("checked")
        .prop("checked", false);
      var handle = $(this).parent().find("input").attr("data-handle");
      var current_ele = $(this).closest(".pro_card_inner").find(".pro_img");
      var current_price = $(this).closest(".pro_card_inner").find(".pro_price");
      var current_title = $(this).closest(".pro_card_inner").find(".pro_title");
      var current_input = $(this).parent().find("input");
      var current_more_size_variant = $(this)
        .closest(".pro_card_inner")
        .find(".more_size");
      $.ajax({
        url: "/products/" + handle + "?view=alternate",
        type: "GET",
        success: function (data) {
          var new_data = $(data).find(".pro_img").html();
          var new_data_price = $(data).find(".pro_price").html();
          var new_data_title = $(data).find(".pro_title").html();
          var new_more_size_variant = $(data).find(".more_size");
          $(current_ele).html(new_data);
          $(current_price).html(new_data_price);
          $(current_title).html(new_data_title);
          $(current_more_size_variant).replaceWith(new_more_size_variant);
          $(current_input).prop("checked", true);
        },
      });
    }
  );

  // cart page & minicart

  // mini html update
  function minicartupdate() {
    $.get("/cart?view=minicart", function (data) {
      $(".mini_cart_wrap").html($(data).find(".mini_cart_wrap").html());
      changeHeight();
    });
  }

  // cart count
  function cartcount() {
    $.getJSON("/cart.js", function (data) {
      $(".cart_item_count").html("(" + data.item_count + ")");
    });
  }

  // cart html update
  function cartupdate() {
    $.get("/cart?view=alternate", function (data) {
      $(".main_cart").html($(data).find(".main_cart").html());
    });
  }

  // cart page quantity button click event
  $("body").on("click", ".main_cart .qty_wrap .qty_btn", function (e) {
    e.preventDefault();
    var input = $(this).parent().find("input");
    var ip = parseInt(input.val());
    if ($(this).hasClass("qty-plus")) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if (ip == 0) {
      return false;
    }
    input.val(ip);
    var id = parseInt(input.attr("data-id"));
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: "updates[" + id + "]=" + ip,
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
      success: function (cart) {},
    });
  });

  // cart page save button click event
  $("body").on("click", ".save_cart a", function (e) {
    e.preventDefault();
    cartupdate();
    cartcount();
    $(".loading-state").removeClass("loading_hide");
    $(".save_cart a span").css("opacity", "0");
    setTimeout(function () {
      $(".loading-state").addClass("loading_hide");
      $(".save_cart a span").css("opacity", "1");
    }, 600);
  });

  // mini cart quantity button click event
  $("body").on("click", ".mini_cart_wrap .qty_wrap .qty_btn", function (e) {
    e.preventDefault();
    var $this = $(this);
    var input = $(this).parent().find("input");
    var ip = parseInt(input.val());
    if ($(this).hasClass("qty-plus")) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    input.val(ip);
    var id = parseInt(input.attr("data-id"));
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: "updates[" + id + "]=" + ip,
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
      success: function (cart) {
        Shopify.getCart(
          function (cart) {
            minicartupdate();
            cartcount();
          }.bind(this)
        );
      },
    });
  });

  // PDP Page Start
  function ajaxAdd(form) {
    // add to cart
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      async: false,
      error: function (jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        $("body").removeClass("loading");
        form.append('<p class="form-error">' + response.description + "</p>");
      },
    }).done(function (data) {
      Shopify.getCart(
        function (cart) {
          form.find("recipient-form").find("input, textarea").val("");
          minicartupdate();
          cartcount();
          setTimeout(function () {
            $("body").addClass("active_cart");
            $(".mini_cart_drower").addClass("active_cart");
          }, 100);
        }.bind(this)
      );
    });
  }

  $("body").on("click", ".qty_btn", function (e) {
    e.preventDefault();
    var ip = parseInt(
      $(this).parents(".pdp_qty").find('input[name="quantity"]').val()
    );
    ip = $(this).hasClass("qty-plus") ? ip + 1 : ip - 1;
    if (ip == 0) {
      return false;
    }
    $(this).parents(".pdp_qty").find('input[name="quantity"]').val(ip);
  });

  $("body").on("click", ".notify_me", function (e) {
    $(".popup_restock").addClass("active");
  });

  $("body").on("click", ".popup_restock .close_popup", function (e) {
    $(".popup_restock").removeClass("active");
  });

  $("body").on("click", "[data-add-to-cart]", function (e) {
    // PDP ATC
    e.preventDefault();
    const form = $(this).closest("form");
    var x = true;
    form.find(".error, .form-error").remove();

    if ($(this).hasClass("notify_me")) return false;

    if (
      form.find("recipient-form").length > 0 &&
      !$(this).hasClass("hardcopyGift")
    ) {
      const email = form
          .find("recipient-form")
          .find('[name="properties[Recipient email]"]'),
        name = form
          .find("recipient-form")
          .find('[name="properties[Recipient name]"]'),
        date = form.find("recipient-form").find('[name="properties[Send on]"]'),
        regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

      if (email.val().trim() == "" || !regex.test(email.val())) {
        var message = "Email can't be blank";
        if (!regex.test(email.val())) {
          message = "Enter Valid Email.";
        }
        email
          .parents(".jo-field-group")
          .append('<p class="error">' + message + "</p>"),
          email.css("border-color", "red").focus();
        x = false;
      } else {
        email.parents(".jo-field-group").find(".error").remove(),
          email.css("border-color", "black");
      }

      if (name.val().trim() == "") {
        var message = "Name can't be blank";
        name
          .parents(".jo-field-group")
          .append('<p class="error">' + message + "</p>"),
          name.css("border-color", "red").focus();
        x = false;
      } else {
        name.parents(".jo-field-group").find(".error").remove(),
          name.css("border-color", "black");
      }

      if (date.val().trim() == "") {
        var message = "Choose Date";
        date
          .parents(".jo-field-group")
          .append('<p class="error">' + message + "</p>"),
          date.css("border-color", "red").focus();
        x = false;
      } else {
        date.parents(".jo-field-group").find(".error").remove(),
          date.css("border-color", "black");
      }

      if (x == false) return false;
    }

    ajaxAdd(form);
  });
  // PDP Page End

  //show back to blog button
  if (document.referrer.indexOf("/blogs/") !== -1) {
    $("#back_to_blog_btn").show();
  }

  //   $('body').on('click','.cart_saver_wrp',function(){
  //     var get_customer = $(this).attr('data-customer');
  //     if(get_customer == 'true'){
  //      $.getJSON('/cart.js',function(data){
  //       var lineItems = [];
  //       for(var i=0;i<data.items.length;i++){
  //         console.log(data.items[i].variant_id,'dataaaaaa');
  //         lineItems = [{ variantId: data.items[i].variant_id, quantity: 1 }];
  //       }
  //       window.cartSaver.createCart(lineItems, { title: "My new cart" });
  //      });
  //    }else{
  //       window.location.href = "/account/login";
  //    }

  // });
});
